// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1B_49","disclaimer":"styles_disclaimer__3XQb7","link":"styles_link__jK9cz","clamp":"styles_clamp__11QZI"};